/* eslint-disable */
import {extendDecorator} from '@/js/common/Domain/Service/mixins/decorators';

@extendDecorator({
    defaults: {
        hotelId: null,
        limit: null,
        numOfComments: null,
        sortCriteria: 'date', //'ratingdesc', 'ratingasc'
        pageNumber: 1,
        showAddCommentForm: false,
        clearData: false,
        comments: null,
        loadingState: 'notLoaded', //'notLoaded', 'loading', 'loaded'
    },
    computeds: {
        numOfPages() {
            const numOfComments = this.get('numOfComments');
            const limit = this.get('limit');

            return limit > 0 ? Math.ceil(numOfComments / limit) : 1;
        },
        nextPageAvailable() {
            return !(this.get('pageNumber') + 1 > this.get('numOfPages'));
        },
        hiddenCommentsNumber() {
            const numOfComments = this.get('numOfComments');
            const limit = this.get('limit');
            const pageNumber = this.get('pageNumber');

            return numOfComments - limit * pageNumber;
        },
        commentsLeftText() {
            const commentsLeft = this.get('hiddenCommentsNumber');
            const limit = this.get('limit');
            const showCommentsLeftNumber = commentsLeft > limit ? limit : commentsLeft;

            return `${showCommentsLeftNumber} отзыв${showCommentsLeftNumber.wordEnding(';а;ов')}`;
        },
    },
})
export default class OurReviewModel extends Backbone.Epoxy.Model {
    initialize() {
        this.set({
            limit: window.numOfCommentsOnPage || 10,
            hotelId: window.appConfig.hotelInfo.id,
        });
    }
}